module.exports = __webpack_public_path__ + "img/dimensie-mentaal_welbevinden.2e49762b.svg";